import { useEffect } from 'react';
import { useAuthStoreBase } from '@fmc-digital/core-auth';

import {
  setAnalyticsOktaId,
  syncAnalyticsOktaIdFromSession,
} from '@/utils/analyticsUserContext';

/**
 * Keeps analytics oktaId in sync with auth store and Okta session storage.
 */
export function useSyncAnalyticsOktaId(): void {
  const oktaId = useAuthStoreBase((state) => state.oktaId);

  useEffect(() => {
    syncAnalyticsOktaIdFromSession();
  }, []);

  useEffect(() => {
    if (oktaId) {
      setAnalyticsOktaId(oktaId);
    }
  }, [oktaId]);
}
